<!-- src/views/DashboardView.vue -->

<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade payment-modal-wrapper"
    id="payments-modal"
    tabindex="-1"
    role="dialog"
    ref="paymentModal"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered payment-modal-dialog"
      role="document"
    >
      <div class="modal-content payment-modal-content">
        <div class="modal-header payment-modal-header">
          <div class="header-title-wrapper">
            <div class="wallet-icon-wrapper">
              <i class="fas fa-wallet"></i>
            </div>
            <h5 class="modal-title payment-title">اختر وسيلة الدفع</h5>
          </div>
          <button type="button" class="close-btn" data-bs-dismiss="modal">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body payment-modal-body">
          <div class="payment-intro">
            <div class="wallet-illustration">
              <img src="@/assets/wallet.png" alt="محفظة" />
              <div class="wallet-glow"></div>
            </div>
            <h3 class="payment-heading">اشحن محفظتك</h3>
            <p class="payment-description">
              اختر وسيلة الدفع المناسبة لك وأكمل عملية الشحن بسهولة
            </p>
          </div>

          <div class="payment-methods">
            <div class="payment-grid">
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#online-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/sadad.png" alt="سداد" />
                  </div>
                  <h5 class="payment-name">Sadad | سداد</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal()"
                data-bs-target="#academia-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/acad-icon.png" alt="بطاقات أكاديميا" />
                  </div>
                  <h5 class="payment-name">بطاقات أكاديميا</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#online-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img
                      src="assets/img/moamalat.jpeg"
                      alt="البطاقة المصرفية"
                    />
                  </div>
                  <h5 class="payment-name">البطاقة المصرفية</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#online-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/mobicash.png" alt="Mobicash" />
                  </div>
                  <h5 class="payment-name">Mobicash | موبي كاش</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#icash-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/icash.png" alt="iCash" />
                  </div>
                  <h5 class="payment-name">iCash | أي كاش</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#online-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/tadawel-new.png" alt="تداول" />
                  </div>
                  <h5 class="payment-name">تداول</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#online-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/edfali.jpeg" alt="إدفع لي" />
                  </div>
                  <h5 class="payment-name">إدفع لي</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#yousrpay-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/YousrPay.png" alt="يسر باي" />
                  </div>
                  <h5 class="payment-name">يسر باي</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal"
                data-bs-target="#musrufypay-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/masrafy-pay.png" alt="مصرفي باي" />
                  </div>
                  <h5 class="payment-name">مصرفي باي</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModalv2()"
                data-bs-target="#lypay-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/ly-pay.png" alt="LY Pay" />
                  </div>
                  <h5 class="payment-name">LY Pay (الحوالات اليدوية)</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal()"
                data-bs-target="#stripe-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/visa.png" alt="Visa" />
                  </div>
                  <h5 class="payment-name">Visa Card</h5>
                </div>
              </div>
              <div
                class="payment-card"
                data-bs-toggle="modal"
                @click="hideModal()"
                data-bs-target="#stripe-modal"
              >
                <div class="payment-card-inner">
                  <div class="payment-logo">
                    <img src="assets/img/mastercard.png" alt="MasterCard" />
                  </div>
                  <h5 class="payment-name">MasterCard</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer payment-modal-footer">
          <button type="button" class="cancel-btn" data-bs-dismiss="modal">
            <i class="fas fa-times-circle"></i>
            <span>إلغاء</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
  <LyPay ref="lyRef" />
</template>

<script>
import {
  apiUrl,
  courseImagePath,
  deviceId,
  getBrowserName,
  api_get,
  api,
  instructorImagePath,
} from "@/utils/api"; // Adjust the import path according to your project structure
import LyPay from "./LyPay.vue";

export default {
  name: "Payments",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
    };
  },
  components: {
    LyPay,
  },
  created() {},
  methods: {
    hideModal() {
      //$("#payments-modal").modal('hide'); // Then hide it after the DOM is updated
      var myModal = new bootstrap.Modal(
        document.getElementById("payments-modal")
      );
      myModal.hide();
    },
    hideModalv2() {
      this.$refs.lyRef.getBanks();
    },
  },
};
</script>

<style scoped>
/* ===== Payment Modal Styles ===== */
.payment-modal-wrapper {
  direction: rtl;
}

.payment-modal-dialog {
  max-width: 700px;
}

.payment-modal-content {
  border: none;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 199, 68, 0.1), 0 30px 100px rgba(0, 0, 0, 0.3);
  background: linear-gradient(180deg, #ffffff 0%, #fafffe 100%);
}

/* Modal Header */
.payment-modal-header {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  padding: 18px 25px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.payment-modal-header::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -10%;
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 70%
  );
  border-radius: 50%;
}

.header-title-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 2;
}

.wallet-icon-wrapper {
  width: 38px;
  height: 38px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.wallet-icon-wrapper i {
  font-size: 16px;
  color: white;
}

.payment-title {
  color: white;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.close-btn {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: rotate(90deg);
}

.close-btn i {
  color: white;
  font-size: 14px;
}

/* Modal Body */
.payment-modal-body {
  padding: 0;
  background: #fafffe;
  max-height: 70vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #00c744 #e8fff1;
}

.payment-modal-body::-webkit-scrollbar {
  width: 8px;
}

.payment-modal-body::-webkit-scrollbar-track {
  background: #e8fff1;
  border-radius: 10px;
}

.payment-modal-body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00c744, #00a83b);
  border-radius: 10px;
}

.payment-modal-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00a83b, #008f32);
}

/* Payment Intro */
.payment-intro {
  text-align: center;
  padding: 25px 20px 20px;
  background: linear-gradient(180deg, #fafffe 0%, #f0fff6 100%);
}

.wallet-illustration {
  position: relative;
  display: inline-block;
  margin-bottom: 12px;
}

.wallet-illustration img {
  width: 80px;
  height: auto;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 10px 30px rgba(0, 199, 68, 0.2));
}

.wallet-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background: radial-gradient(
    circle,
    rgba(0, 199, 68, 0.15) 0%,
    transparent 70%
  );
  border-radius: 50%;
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.8;
  }
}

.payment-heading {
  color: #1a202c;
  font-size: 1.3rem;
  font-weight: 800;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.payment-description {
  color: #64748b;
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.5;
}

/* Payment Methods */
.payment-methods {
  padding: 20px;
}

.payment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
}

.payment-card {
  background: white;
  border-radius: 18px;
  border: 2px solid rgba(0, 199, 68, 0.1);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

.payment-card:hover {
  transform: translateY(-8px);
  border-color: #00c744;
  box-shadow: 0 20px 50px rgba(0, 199, 68, 0.15);
}

.payment-card-inner {
  padding: 18px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.payment-logo {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.payment-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: grayscale(20%);
  transition: all 0.3s ease;
}

.payment-card:hover .payment-logo img {
  filter: grayscale(0%);
  transform: scale(1.05);
}

.payment-name {
  font-size: 0.75rem;
  font-weight: 600;
  color: #2d3748;
  text-align: center;
  margin: 0;
  line-height: 1.3;
}

/* Modal Footer */
.payment-modal-footer {
  background: linear-gradient(180deg, #f0fff6 0%, #e8fff1 100%);
  border-top: 1px solid rgba(0, 199, 68, 0.1);
  padding: 15px 25px;
  display: flex;
  justify-content: center;
}

.cancel-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 50px;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.cancel-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.cancel-btn i {
  font-size: 0.9rem;
  color: #64748b;
}

/* Responsive */
@media (max-width: 768px) {
  .payment-modal-dialog {
    margin: 10px;
  }

  .payment-modal-header {
    padding: 20px 25px;
  }

  .payment-title {
    font-size: 1.2rem;
  }

  .wallet-icon-wrapper {
    width: 45px;
    height: 45px;
  }

  .payment-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }

  .payment-intro {
    padding: 30px 20px 20px;
  }

  .payment-heading {
    font-size: 1.5rem;
  }

  .payment-methods {
    padding: 20px;
  }
}

/* Dark Mode Support */
[data-bs-theme="dark"] .payment-modal-content,
[data-theme="dark"] .payment-modal-content,
.dark .payment-modal-content {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
}

[data-bs-theme="dark"] .payment-modal-body,
[data-theme="dark"] .payment-modal-body,
.dark .payment-modal-body {
  background: #0f172a;
}

[data-bs-theme="dark"] .payment-intro,
[data-theme="dark"] .payment-intro,
.dark .payment-intro {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
}

[data-bs-theme="dark"] .payment-heading,
[data-theme="dark"] .payment-heading,
.dark .payment-heading {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .payment-description,
[data-theme="dark"] .payment-description,
.dark .payment-description {
  color: #94a3b8;
}

[data-bs-theme="dark"] .payment-card,
[data-theme="dark"] .payment-card,
.dark .payment-card {
  background: #1e293b;
  border-color: rgba(0, 199, 68, 0.2);
}

[data-bs-theme="dark"] .payment-name,
[data-theme="dark"] .payment-name,
.dark .payment-name {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .payment-modal-footer,
[data-theme="dark"] .payment-modal-footer,
.dark .payment-modal-footer {
  background: linear-gradient(180deg, #0f172a 0%, #1a2744 100%);
}

[data-bs-theme="dark"] .cancel-btn,
[data-theme="dark"] .cancel-btn,
.dark .cancel-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

[data-bs-theme="dark"] .cancel-btn:hover,
[data-theme="dark"] .cancel-btn:hover,
.dark .cancel-btn:hover {
  background: #334155;
  border-color: #475569;
}
</style>
